import { DriftEnv } from '@drift-labs/sdk';
import { useCallback } from 'react';
import { DriftWindow } from 'src/window/driftWindow';
import { useGetClientsForNewConnection } from './useGetClientsForNewConnection';
import { useSubscribeDriftClient } from './useSubscribeDriftClient';
import { useHandleSubscriptionSuccess } from './useHandleSubscriptionSuccess';
import { useUnsubscribeClients } from './useUnsubscribeClients';
import { RpcEndpoint } from '@drift/common';
import { SubscriberType } from 'src/environmentVariables/EnvironmentVariables';

export const useRunConnectionSteps = () => {
	const { getClientsForNewConnection } = useGetClientsForNewConnection();
	const { subscribeToDriftClientData } = useSubscribeDriftClient();
	const { handleSubscriptionSuccess } = useHandleSubscriptionSuccess();
	const { unsubscribeClients } = useUnsubscribeClients();

	const runConnectionSteps = useCallback(
		async (
			newRpc: RpcEndpoint,
			subscriberType: SubscriberType,
			env: DriftEnv
		) => {
			try {
				await unsubscribeClients();

				const newClients = getClientsForNewConnection(
					newRpc,
					subscriberType,
					env
				);

				const connectionResult = await subscribeToDriftClientData(
					newClients.newDriftClient
				);

				DriftWindow.recordStartupTimeMetric('driftClientSubscribe');

				if (connectionResult) {
					handleSubscriptionSuccess({
						selectedRpc: newRpc,
						...newClients,
					});
				}

				return connectionResult;
			} catch (e: any) {
				console.log(`Caught error running connection steps`);
				console.error(e);
				return false;
			}
		},
		[
			getClientsForNewConnection,
			subscribeToDriftClientData,
			handleSubscriptionSuccess,
			unsubscribeClients,
		]
	);

	return { runConnectionSteps };
};
